/**
 * Scroll Lock Utility
 *
 * Prevent background (page) scrolling while overlays/modals are open.
 * Uses a simple reference count so multiple modals can coexist.
 */

interface OriginalStyles {
    htmlOverflow: string;
    bodyOverflow: string;
    bodyPaddingRight: string;
}

let lockCount = 0;

function createOriginalStylesSlot(): OriginalStyles | null {
    return null;
}

let originalStyles = createOriginalStylesSlot();

export class ScrollLock {
    private static _getScrollbarWidth(): number {
        const body = document.body;
        if (!body) return 0;

        const scrollBox = document.createElement("div");
        scrollBox.style.visibility = "hidden";
        scrollBox.style.position = "absolute";
        scrollBox.style.top = "-9999px";
        scrollBox.style.width = "100px";
        scrollBox.style.height = "100px";
        scrollBox.style.overflow = "scroll";
        scrollBox.style.border = "0";
        scrollBox.style.padding = "0";

        body.appendChild(scrollBox);
        const width = scrollBox.offsetWidth - scrollBox.clientWidth;
        scrollBox.remove();

        return width > 0 ? width : 0;
    }

    public static lock(): void {
        lockCount += 1;
        if (lockCount > 1) {
            return;
        }

        const html = document.documentElement;
        const body = document.body;

        originalStyles = {
            htmlOverflow: html.style.overflow,
            bodyOverflow: body.style.overflow,
            bodyPaddingRight: body.style.paddingRight,
        };

        const scrollbarWidth = ScrollLock._getScrollbarWidth();

        html.style.overflow = "hidden";
        body.style.overflow = "hidden";

        if (scrollbarWidth > 0) {
            body.style.paddingRight = `${scrollbarWidth}px`;
        }
    }

    public static unlock(): void {
        if (lockCount === 0) {
            return;
        }

        lockCount -= 1;
        if (lockCount > 0) {
            return;
        }

        const html = document.documentElement;
        const body = document.body;

        if (!originalStyles) {
            html.style.overflow = "";
            body.style.overflow = "";
            body.style.paddingRight = "";
            return;
        }

        html.style.overflow = originalStyles.htmlOverflow;
        body.style.overflow = originalStyles.bodyOverflow;
        body.style.paddingRight = originalStyles.bodyPaddingRight;

        originalStyles = null;
    }
}
